import React from "react";
import { useSelector } from "react-redux";
import iconsList from "../../../ui/icons/iconsList";
import useMyLearningDomains from "../useMyLearningDomains";
import WidgetDomainCard from "./widgetDomainCard/WidgetDomainCard";
import Widget from "../../../features/widget/Widget";
import pathRouts from "../../../../enums/pathRoute";
import { deviceTypes } from "../../../../enums/deviceTypes";
import classes from './MyLearningWidget.module.css';

const MyLearningWidget = ({ width }) => {
    
    const myDomains = useMyLearningDomains();
    const { texts } = useSelector(state => state.translate);
    const { deviceType } = useSelector(state => state.responsive);
    const isMobile = deviceType === deviceTypes.mobile;

    return (
        <Widget
            color="#FDDB71"
            width={width || 250}
            height={529}
            mainLink={`/${pathRouts.MYLEARNING}`}
            links={isMobile ? [] : [
                { text: texts.allMyAssessments, to: `/${pathRouts.MYLEARNING}` }
            ]}
            title={texts.myLearning}
            icon={iconsList.myLearning}
            className={classes.MyLearningWidget}
        >
            <div className={classes.DomainsList}>
                {myDomains?.map(domain => (
                    <WidgetDomainCard key={domain.name} domain={domain} />
                ))}
            </div>
        </Widget>
    );
};

export default MyLearningWidget;